import Storage from '@/utils/storagehandle'
const app = {
    namespaced: true,
    state: {
        // 菜单选中
        menuAction: Storage.getItem('menuAction')||'/',
        teachAction: Storage.getItem('teachAction')||1
    },
    mutations: {
        // 修改赛事的全局数据
        CHANGE_MENU_ACTION (state, menuAction) {
            state.menuAction = menuAction
            Storage.setItem(`menuAction`, state.menuAction)
        },
        CHANGE_TEACH_ACTION (state, teachAction) {
            state.teachAction = teachAction
            Storage.setItem(`teachAction`, state.teachAction)
        }
    },
    actions: {
    },
    getters: {
        menuAction: state => state.menuAction,
        teachAction: state => state.teachAction
    }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js